import * as GeneralPhrases from './generalPhrases';
import * as HeaderPhrases from './headerPhrases';
import * as RegistrationPhrases from './registrationPhrases';
import * as LoginPhrases from './loginPhrases';
import * as IntroPhrases from './introPhrases';
import * as AccountPhrases from './accountPhrases';
import * as DynamicProfilingPhrases from './dynamicProfilingPhrases';
import * as SurveyPhrases from './surveyPhrases';
import * as WalletPhrases from './walletPhrases';
import * as StaticPagesPhrases from './staticPagesPhrases';
import * as NMDashboardPhrases from './nmDashboardPhrases';
import * as IdentityVerificationPhrases from './identityVerificationPhrases';
import * as SelectOpinionPhrases from './selectOpinionPhrases';

export const Phrases = {
    ...GeneralPhrases.GENERAL_PHRASES,
    ...HeaderPhrases.HEADER_PHRASES,
    ...LoginPhrases.LOGIN_PHRASES,
    ...LoginPhrases.PASSWORD_RESET_PHRASES,
    ...RegistrationPhrases.REGISTER_INTRO_BLOCK,
    ...RegistrationPhrases.FORM_STEP_PHRASES,
    ...RegistrationPhrases.PERSONAL_DETAILS_PHRASES,
    ...RegistrationPhrases.IDENTITY_PHRASES,
    ...RegistrationPhrases.ACTIVATE_PHRASES,
    ...RegistrationPhrases.CONTACT_DETAILS_PHRASES,
    ...IntroPhrases.INTRO_PHRASES,
    ...AccountPhrases.ACCOUNT_GENERAL_PHRASES,
    ...AccountPhrases.ACCOUNT_MENU_PHRASES,
    ...AccountPhrases.ACCOUNT_PERSONAL_DETAILS_PHRASES,
    ...AccountPhrases.ACCOUNT_PROFESSIONAL_DETAILS_PHRASES,
    ...AccountPhrases.ACCOUNT_PASSWORD_CHANGE_PHRASES,
    ...DynamicProfilingPhrases.DYNAMIC_PROFILING_GENERAL_PHRASES,
    ...DynamicProfilingPhrases.DYNAMIC_PROFILING_INTRO_PHRASES,
    ...DynamicProfilingPhrases.DYNAMIC_PROFILING_QUESTION_PHRASES,
    ...DynamicProfilingPhrases.DYNAMIC_PROFILING_CONTROL_PHRASES,
    ...SurveyPhrases.SURVEY_PHRASES,
    ...SurveyPhrases.SURVEY_HISTORY_PHRASES,
    ...WalletPhrases.WALLET_PHRASES,
    ...WalletPhrases.WALLET_REQUEST_PHRASES,
    ...WalletPhrases.WALLET_PAYMENT_DETAILS_PHRASES,
    ...WalletPhrases.WALLET_CONFIRMATION_PHRASES,
    ...WalletPhrases.WALLET_NON_MEMBER_PHRASES,
    ...StaticPagesPhrases.STATIC_PAGES_PHRASES,
    ...NMDashboardPhrases.NM_DASHBOARD_PHRASES,
    ...IdentityVerificationPhrases.IDENTITY_VERIFICATION_PHRASES,
    ...SelectOpinionPhrases.SELECT_OPINION_PHRASES,
} as const;
